import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = { class: "font-semibold text-para-xs md:text-para-s" }
const _hoisted_3 = {
  key: 0,
  "aria-hidden": "true",
  title: "required"
}
const _hoisted_4 = ["id", "name", "type", "value", "aria-invalid", "aria-describedby"]
const _hoisted_5 = ["for"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'mt-2': !$props.title })
  }, [
    _createElementVNode("fieldset", {
      class: _normalizeClass(["flex flex-col gap-y-2 gap-x-4 mt-2", { 'md:flex-row flex-wrap': $props.horizontal }])
    }, [
      (!_ctx.hideTitle)
        ? (_openBlock(), _createElementBlock("legend", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, [
              _createTextVNode(_toDisplayString($props.title) + " ", 1),
              ($props.required)
                ? (_openBlock(), _createElementBlock("dfn", _hoisted_3, _toDisplayString($props.requiredSymbol), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.options, (label, iValue, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "flex flex-row items-center"
        }, [
          _createVNode(_component_Field, {
            ref_for: true,
            ref: "field",
            modelValue: $data.model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.model) = $event)),
            name: $props.name,
            label: $props.title,
            rules: $options.rules,
            disabled: $props.disabled,
            type: 'checkbox',
            value: iValue,
            as: "div"
          }, {
            default: _withCtx(({ field, errors }) => [
              _createElementVNode("input", _mergeProps({ ref_for: true }, field, {
                id: $options.isSingle ? $props.name : `${$props.name}-${index}`,
                name: $props.name,
                class: "absolute opacity-0 text-black-900 text-para-xs md:text-para-s",
                type: $props.type,
                value: iValue,
                "aria-invalid": errors.length > 0,
                "aria-describedby": errors.length > 0 ? `${$props.name}-error` : ''
              }), null, 16, _hoisted_4),
              _createElementVNode("label", {
                for: $options.isSingle ? $props.name : `${$props.name}-${index}`,
                class: _normalizeClass(["relative", $props.type + '-label'])
              }, [
                _createElementVNode("span", {
                  class: "text-para-xs pl-5 md:pl-6",
                  innerHTML: label
                }, null, 8, _hoisted_6)
              ], 10, _hoisted_5)
            ]),
            _: 2
          }, 1032, ["modelValue", "name", "label", "rules", "disabled", "value"])
        ]))
      }), 128)),
      _createVNode(_component_ErrorMessage, { name: $props.name }, {
        default: _withCtx(({ message }) => [
          _createElementVNode("span", {
            id: `${$props.name}-error`,
            class: "text-error text-para-xs mt-1 md:mt-2"
          }, _toDisplayString(message), 9, _hoisted_7)
        ]),
        _: 1
      }, 8, ["name"])
    ], 2)
  ], 2))
}